// T-189 (v1.8.59, Session 45, 05.10.2026): "Buchung anpassen" im Kundenkonto ab der Annahme des Angebots, unabhängig von der Zahlung
// (Kundin-Mail 05.10.2026 17:50, Vorschlag Gesamtmail v4 Punkt 11). Gleiche Liste wie der Server (Business.Buchung.Selbstanpassung,
// SelfServiceBookingService.CheckAvailabilityAsync); die Fristen (Extras 7 Tage, Teilnehmer 24 Stunden vor der Fahrt) prüft der Server.
// Bisher nur Confirmed und Paid (BookingHistory.tsx). Reine Funktion, getestet in selbstanpassung.test.ts.
import { statusCode } from './buchungsstatus';

export const ANPASSEN_STATUS: readonly string[] = [
  'OfferAccepted',
  'Confirmed',
  'PaymentPending',
  'AwaitingFinalPayment',
  'PartiallyPaid',
  'FullyPaid',
  'Paid',
];

/** true, wenn der Gast die Buchung in diesem Status selbst anpassen darf (Status als Text oder API-Objekt). */
export function buchungAnpassbar(status: unknown): boolean {
  return ANPASSEN_STATUS.includes(statusCode(status));
}
